import { render, staticRenderFns } from "./DialogBuySite.vue?vue&type=template&id=12dc87e7&scoped=true&"
import script from "./DialogBuySite.vue?vue&type=script&lang=js&"
export * from "./DialogBuySite.vue?vue&type=script&lang=js&"
import style0 from "./DialogBuySite.vue?vue&type=style&index=0&id=12dc87e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc87e7",
  null
  
)

export default component.exports